<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> person </v-icon>
      <span :class="ui.textHeadline"> User Review </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Review users, licence and access level approvals. Validate authorisation levels and privileges.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <v-spacer/>
        <SearchUser :data="{title: 'User Search', tag: 'U1'}"/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import SearchUser from "@/data/search/components/SearchUser";

export default {
  mixins: [apptheme],
  components: {
    SearchUser
  }
};
</script>
